export default __webpack_public_path__ + "e295f70fe3e2df296c7bd1082d39afda.woff2";